module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_trend_down-5497fdfa2bb9425b1f998fadeae2689b.svg";